//videos
import Video01a from './assets/videos/origami/01a_fold-1.mp4';
import Video01b from './assets/videos/origami/01b_fold-2.mp4';
import Video01c from './assets/videos/origami/01c_fold-3.mp4';
import Video01d from './assets/videos/origami/01d_fold-4.mp4';
import Video01e from './assets/videos/origami/01e_fold-5.mp4';
import Video01f from './assets/videos/origami/01f_fold-6.mp4';
import Video02a from './assets/videos/origami/02a_fold-7.mp4';
import Video02b from './assets/videos/origami/02b_fold-8.mp4';
import Video02c from './assets/videos/origami/02c_fold-9.mp4';
import Video02d from './assets/videos/origami/02d_fold-10.mp4';
import Video02e from './assets/videos/origami/02e_fold-11.mp4';
import Video02f from './assets/videos/origami/02f_fold-12.mp4';
import Video03a from './assets/videos/origami/03a_fold-13.mp4';
import Video03b from './assets/videos/origami/03b_fold-14.mp4';
import Video03c from './assets/videos/origami/03c_fold-15.mp4';
import Video03d from './assets/videos/origami/03d_fold-16.mp4';
import Video03e from './assets/videos/origami/03e_fold-17.mp4';
import Video03f from './assets/videos/origami/03f_fold-18.mp4';
import Video04a from './assets/videos/origami/04a_fold-19.mp4';
import Video04b from './assets/videos/origami/04b_fold-20.mp4';
import Video04c from './assets/videos/origami/04c_fold-21.mp4';
import Video04d from './assets/videos/origami/04d_fold-22.mp4';
import Video04e from './assets/videos/origami/04e_fold-23.mp4';
import Video04f from './assets/videos/origami/04f_fold-24.mp4';

//videos portrait for mobile portait only
import VideoPort01a from './assets/videos/origami/portrait/01a_fold-1.mp4';
import VideoPort01b from './assets/videos/origami/portrait/01b_fold-2.mp4';
import VideoPort01c from './assets/videos/origami/portrait/01c_fold-3.mp4';
import VideoPort01d from './assets/videos/origami/portrait/01d_fold-4.mp4';
import VideoPort01e from './assets/videos/origami/portrait/01e_fold-5.mp4';
import VideoPort01f from './assets/videos/origami/portrait/01f_fold-6.mp4';
import VideoPort02a from './assets/videos/origami/portrait/02a_fold-7.mp4';
import VideoPort02b from './assets/videos/origami/portrait/02b_fold-8.mp4';
import VideoPort02c from './assets/videos/origami/portrait/02c_fold-9.mp4';
import VideoPort02d from './assets/videos/origami/portrait/02d_fold-10.mp4';
import VideoPort02e from './assets/videos/origami/portrait/02e_fold-11.mp4';
import VideoPort02f from './assets/videos/origami/portrait/02f_fold-12.mp4';
import VideoPort03a from './assets/videos/origami/portrait/03a_fold-13.mp4';
import VideoPort03b from './assets/videos/origami/portrait/03b_fold-14.mp4';
import VideoPort03c from './assets/videos/origami/portrait/03c_fold-15.mp4';
import VideoPort03d from './assets/videos/origami/portrait/03d_fold-16.mp4';
import VideoPort03e from './assets/videos/origami/portrait/03e_fold-17.mp4';
import VideoPort03f from './assets/videos/origami/portrait/03f_fold-18.mp4';
import VideoPort04a from './assets/videos/origami/portrait/04a_fold-19.mp4';
import VideoPort04b from './assets/videos/origami/portrait/04b_fold-20.mp4';
import VideoPort04c from './assets/videos/origami/portrait/04c_fold-21.mp4';
import VideoPort04d from './assets/videos/origami/portrait/04d_fold-22.mp4';
import VideoPort04e from './assets/videos/origami/portrait/04e_fold-23.mp4';
import VideoPort04f from './assets/videos/origami/portrait/04f_fold-24.mp4';

//folded images
import Folded01a from './assets/images/Origami/folded/01a_folded.png';
import Folded01b from './assets/images/Origami/folded/01b_folded.png';
import Folded01c from './assets/images/Origami/folded/01c_folded.png';
import Folded01d from './assets/images/Origami/folded/01d_folded.png';
import Folded01e from './assets/images/Origami/folded/01e_folded.png';
import Folded01f from './assets/images/Origami/folded/01f_folded.png';
import Folded02a from './assets/images/Origami/folded/02a_folded.png';
import Folded02b from './assets/images/Origami/folded/02b_folded.png';
import Folded02c from './assets/images/Origami/folded/02c_folded.png';
import Folded02d from './assets/images/Origami/folded/02d_folded.png';
import Folded02e from './assets/images/Origami/folded/02e_folded.png';
import Folded02f from './assets/images/Origami/folded/02f_folded.png';
import Folded03a from './assets/images/Origami/folded/03a_folded.png';
import Folded03b from './assets/images/Origami/folded/03b_folded.png';
import Folded03c from './assets/images/Origami/folded/03c_folded.png';
import Folded03d from './assets/images/Origami/folded/03d_folded.png';
import Folded03e from './assets/images/Origami/folded/03e_folded.png';
import Folded03f from './assets/images/Origami/folded/03f_folded.png';
import Folded04a from './assets/images/Origami/folded/04a_folded.png';
import Folded04b from './assets/images/Origami/folded/04b_folded.png';
import Folded04c from './assets/images/Origami/folded/04c_folded.png';
import Folded04d from './assets/images/Origami/folded/04d_folded.png';
import Folded04e from './assets/images/Origami/folded/04e_folded.png';
import Folded04f from './assets/images/Origami/folded/04f_folded.png';

import assetHashMap from './origamiSelectionToStaticAsset.json';

export const colors = [
  {
    id: 0,
    name: 'color-0',
  },
  {
    id: 1,
    name: 'color-1',
  },
  {
    id: 2,
    name: 'color-2',
  },
  {
    id: 3,
    name: 'color-3',
  },
];

export const patterns = [
  {
    id: 0,
    image: 'image-0',
    name: 'pattern-0',
    description: `origami.pattern1.description`,
  },
  {
    id: 1,
    name: 'pattern-1',
    image: 'image-1',
    description: 'origami.pattern2.description',
  },
  {
    id: 2,
    name: 'pattern-2',
    image: 'image-2',
    description: 'origami.pattern3.description',
  },
  {
    id: 3,
    name: 'pattern-3',
    image: 'image-3',
    description: 'origami.pattern4.description',
  },
  {
    id: 4,
    name: 'pattern-4',
    image: 'image-4',
    description: 'origami.pattern5.description',
  },
  {
    id: 5,
    name: 'pattern-5',
    image: 'image-5',
    description: 'origami.pattern6.description',
  },
];

export const messages = [
  {
    id: 0,
    text: `origami.message1.copyUser`,
    disclaimer: `origami.message1.copyNissan`,
    canvas: {
      text: [`origami.message1.copyUserLine1`, `origami.message1.copyUserLine2`],
      disclaimer: [`origami.message1.copyNissanLine1`, `origami.message1.copyNissanLine2`],
    },
  },
  {
    id: 1,
    text: `origami.message2.copyUser`,
    disclaimer: `origami.message2.copyNissan`,
    canvas: {
      text: [`origami.message2.copyUserLine1`, `origami.message2.copyUserLine2`],
      disclaimer: [`origami.message2.copyNissanLine1`, `origami.message2.copyNissanLine2`],
    },
  },
  {
    id: 2,
    text: `origami.message3.copyUser`,
    disclaimer: `origami.message3.copyNissan`,
    canvas: {
      text: [`origami.message3.copyUserLine1`, `origami.message3.copyUserLine2`],
      disclaimer: [`origami.message3.copyNissanLine1`, `origami.message3.copyNissanLine2`],
    },
  },
  {
    id: 3,
    text: `origami.message4.copyUser`,
    disclaimer: `origami.message4.copyNissan`,
    canvas: {
      text: [`origami.message4.copyUserLine1`, `origami.message4.copyUserLine2`],
      disclaimer: [`origami.message4.copyNissanLine1`, `origami.message4.copyNissanLine2`],
    },
  },
  {
    id: 4,
    text: `origami.message5.copyUser`,
    disclaimer: `origami.message5.copyNissan`,
    canvas: {
      text: [`origami.message5.copyUserLine1`, `origami.message5.copyUserLine2`],
      disclaimer: [`origami.message5.copyNissanLine1`, `origami.message5.copyNissanLine2`],
    },
  },
  {
    id: 5,
    text: `origami.message6.copyUser`,
    disclaimer: `origami.message6.copyNissan`,
    canvas: {
      text: [`origami.message6.copyUserLine1`, `origami.message6.copyUserLine2`],
      disclaimer: [`origami.message6.copyNissanLine1`, `origami.message6.copyNissanLine2`],
    },
  },
  {
    id: 6,
    text: `origami.message7.copyUser`,
    disclaimer: `origami.message7.copyNissan`,
    canvas: {
      text: [`origami.message7.copyUserLine1`, `origami.message7.copyUserLine2`],
      disclaimer: [`origami.message7.copyNissanLine1`, `origami.message7.copyNissanLine2`],
    },
  },
  {
    id: 7,
    text: `origami.message8.copyUser`,
    disclaimer: `origami.message8.copyNissan`,
    canvas: {
      text: [`origami.message8.copyUserLine1`, `origami.message8.copyUserLine2`],
      disclaimer: [`origami.message8.copyNissanLine1`, `origami.message8.copyNissanLine2`],
    },
  },
  {
    id: 8,
    text: `origami.message9.copyUser`,
    disclaimer: `origami.message9.copyNissan`,
    canvas: {
      text: [`origami.message9.copyUserLine1`, `origami.message9.copyUserLine2`],
      disclaimer: [`origami.message9.copyNissanLine1`, `origami.message9.copyNissanLine2`],
    },
  },
  {
    id: 9,
    text: `origami.message10.copyUser`,
    disclaimer: `origami.message10.copyNissan`,
    canvas: {
      text: [`origami.message10.copyUserLine1`, `origami.message10.copyUserLine2`],
      disclaimer: [`origami.message10.copyNissanLine1`, `origami.message10.copyNissanLine2`],
    },
  },
];

export const foldedAssets = [
  {
    color: 0,
    pattern: 0,
    video: Video01a,
    videoPort: VideoPort01a,
    image: Folded01a,
  },
  {
    color: 0,
    pattern: 1,
    video: Video01b,
    videoPort: VideoPort01b,
    image: Folded01b,
  },
  {
    color: 0,
    pattern: 2,
    video: Video01c,
    videoPort: VideoPort01c,
    image: Folded01c,
  },
  {
    color: 0,
    pattern: 3,
    video: Video01d,
    videoPort: VideoPort01d,
    image: Folded01d,
  },
  {
    color: 0,
    pattern: 4,
    video: Video01e,
    videoPort: VideoPort01e,
    image: Folded01e,
  },
  {
    color: 0,
    pattern: 5,
    video: Video01f,
    videoPort: VideoPort01f,
    image: Folded01f,
  },
  {
    color: 1,
    pattern: 0,
    video: Video02a,
    videoPort: VideoPort02a,
    image: Folded02a,
  },
  {
    color: 1,
    pattern: 1,
    video: Video02b,
    videoPort: VideoPort02b,
    image: Folded02b,
  },
  {
    color: 1,
    pattern: 2,
    video: Video02c,
    videoPort: VideoPort02c,
    image: Folded02c,
  },
  {
    color: 1,
    pattern: 3,
    video: Video02d,
    videoPort: VideoPort02d,
    image: Folded02d,
  },
  {
    color: 1,
    pattern: 4,
    video: Video02e,
    videoPort: VideoPort02e,
    image: Folded02e,
  },
  {
    color: 1,
    pattern: 5,
    video: Video02f,
    videoPort: VideoPort02f,
    image: Folded02f,
  },
  {
    color: 2,
    pattern: 0,
    video: Video03a,
    videoPort: VideoPort03a,
    image: Folded03a,
  },
  {
    color: 2,
    pattern: 1,
    video: Video03b,
    videoPort: VideoPort03b,
    image: Folded03b,
  },
  {
    color: 2,
    pattern: 2,
    video: Video03c,
    videoPort: VideoPort03c,
    image: Folded03c,
  },
  {
    color: 2,
    pattern: 3,
    video: Video03d,
    videoPort: VideoPort03d,
    image: Folded03d,
  },
  {
    color: 2,
    pattern: 4,
    video: Video03e,
    videoPort: VideoPort03e,
    image: Folded03e,
  },
  {
    color: 2,
    pattern: 5,
    video: Video03f,
    videoPort: VideoPort03f,
    image: Folded03f,
  },
  {
    color: 3,
    pattern: 0,
    video: Video04a,
    videoPort: VideoPort04a,
    image: Folded04a,
  },
  {
    color: 3,
    pattern: 1,
    video: Video04b,
    videoPort: VideoPort04b,
    image: Folded04b,
  },
  {
    color: 3,
    pattern: 2,
    video: Video04c,
    videoPort: VideoPort04c,
    image: Folded04c,
  },
  {
    color: 3,
    pattern: 3,
    video: Video04d,
    videoPort: VideoPort04d,
    image: Folded04d,
  },
  {
    color: 3,
    pattern: 4,
    video: Video04e,
    videoPort: VideoPort04e,
    image: Folded04e,
  },
  {
    color: 3,
    pattern: 5,
    video: Video04f,
    videoPort: VideoPort04f,
    image: Folded04f,
  },
];
function getID(config) {
  return [config.locale, config.color.id, config.pattern.id, config.message.id].join('_');
}

function getHashForConfig(config) {
  const id = getID(config);
  return assetHashMap[id];
}

export function createShareUrl(locale, color, pattern, message) {
  const hash = getHashForConfig({ locale, color, pattern, message });
  const url = new URL(window.location.href);

  if (process.env.NODE_ENV === 'production') {
    url.hash = '';
    if (url.pathname.indexOf('index.html') !== -1) {
      url.pathname = url.pathname.replace('index.html', `share/${hash}.html`);
	} else if (url.pathname.indexOf('share/') !== -1){
	  url.pathname = url.pathname.replace(/share.+/, `share/${hash}.html`);
    } else {
      url.pathname = `/share/${hash}.html`;
    }
  } else {
    url.hash = `#/${locale}/origami-share/${color.id}/${pattern.id}/${message.id}`;
  }
  return url.toString();
}
